import { render, staticRenderFns } from "./BalanceOutputEmpty.vue?vue&type=template&id=243d70d2&scoped=true"
import script from "./BalanceOutputEmpty.vue?vue&type=script&lang=js"
export * from "./BalanceOutputEmpty.vue?vue&type=script&lang=js"
import style0 from "./BalanceOutputEmpty.vue?vue&type=style&index=0&id=243d70d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d70d2",
  null
  
)

export default component.exports